import Skeleton from "@mui/material/Skeleton";
import classNames from "classnames";
import React from "react";

type Props = {};

const RenderLoading = (props: Props) => {
  return (
    <div className={classNames("activities-container", "row")}>
      <div className="col-12 h-1/2">
        <div className="h-full w-full row items-center">
          <Skeleton variant="text" width={100} height={30} className="col-2" />

          <div className="col-12 flex h-[70%] gap-4">
            {Array(4)
              .fill(0)
              .map((_, i) => (
                <Skeleton
                  key={i}
                  variant="rounded"
                  className="flex-1"
                  height="100%"
                />
              ))}
          </div>
        </div>
        <div className="h-full w-full row items-center">
          <Skeleton variant="text" width={100} height={30} className="col-2" />

          <div className="col-12 flex h-[70%] gap-4">
            {Array(4)
              .fill(0)
              .map((_, i) => (
                <Skeleton
                  key={i}
                  variant="rounded"
                  className="flex-1"
                  height="100%"
                />
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RenderLoading;
